import { render } from "./PatientTherapy.vue?vue&type=template&id=65077e5f"
import script from "./PatientTherapy.vue?vue&type=script&lang=js"
export * from "./PatientTherapy.vue?vue&type=script&lang=js"

import "./PatientTherapy.vue?vue&type=style&index=0&id=65077e5f&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/DACY_Demo_Server/kbdemo_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__